import { FC } from 'react';

import SelfDrawingPath from './SelfDrawingPath/SelfDrawingPath';
import BezierPathDemo from './BezierPathDemo';
import DraggableArcDemo from './DraggableArcDemo';
import CustomSvg from './CustomSvg';
import ArcRadiusDemo from './ArcRadiusDemo';
import ArcSweepDemo from './ArcSweepDemo';
import ArcWithBall from './ArcWithBall';
import ArcRotateDemo from './ArcRotateDemo';
import RelativeCommandsDemo from './RelativeCommandsDemo/RelativeCommandsDemo';
import MiterAngleDemo from './MiterAngleDemo';
import ClosePathDemo from './ClosePathDemo';

type DemoComponent = FC<Record<string, unknown>>;

const MAP: Record<string, DemoComponent> = {
  // TypeScript doesn’t even type-check stuff in MDX files, and these components are called exclusively from MDX posts, so there’s no point in setting up type-checking for props.
  // @ts-expect-error
  SelfDrawingPath,
  // @ts-expect-error
  BezierPathDemo,
  DraggableArcDemo,
  // @ts-expect-error
  CustomSvg,
  ArcRadiusDemo,
  ArcSweepDemo,
  ArcRotateDemo,
  // @ts-expect-error
  ArcWithBall,
  RelativeCommandsDemo,
  MiterAngleDemo,
  ClosePathDemo,
};

interface PathsDemoProps {
  componentName: keyof typeof MAP;
  [key: string]: unknown;
}

export default function PathsDemo({
  componentName,
  ...props
}: PathsDemoProps) {
  const Component = MAP[componentName];
  return <Component {...props} />;
}
